import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Map, Smartphone, Zap, Users, Shield } from 'lucide-react';

const WhyMetroRahiSection = () => {
  const comparisonData = [
    {
      traditional: {
        icon: Clock,
        title: "Traditional Navigation",
        features: ["Paper maps", "Fixed schedules", "No real-time updates", "Limited routes", "Manual calculations"],
        color: "#ff6b6b"
      },
      metroRahi: {
        icon: Smartphone,
        title: "MetroRahi Experience",
        features: ["Live navigation", "Station alerts", "Location sharing", "Disruption alerts", "Multi-language support"],
        color: "#00F5D4"
      }
    }
  ];

  const benefits = [
    {
      icon: Zap,
      title: "10x Faster",
      description: "Find optimal routes in seconds instead of minutes",
      color: "#00F5D4"
    },
    {
      icon: Users,
      title: "Community Driven",
      description: "Real-time crowd data and user-generated insights",
      color: "#3D5AFE"
    },
    {
      icon: Shield,
      title: "Always Safe",
      description: "Real-time alerts for delays and platform changes",
      color: "#9D4EDD"
    }
  ];

  return (
    <section className="why-metro-rahi-section section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Why MetroRahi?</h2>
          <p className="section-subtitle">
            Experience the evolution from traditional metro navigation to the future
          </p>
        </motion.div>

        {/* Comparison Infographic */}
        <motion.div
          className="comparison-container"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="comparison-grid">
            {/* Traditional Side */}
            <motion.div
              className="comparison-card traditional"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <div className="card-header">
                <div className="icon-container traditional-icon">
                  <Clock className="icon" />
                </div>
                <h3>Traditional Navigation</h3>
              </div>
              <ul className="feature-list">
                <li>📄 Paper maps</li>
                <li>⏰ Fixed schedules</li>
                <li>❌ No real-time updates</li>
                <li>🔄 Limited routes</li>
                <li>🧮 Manual calculations</li>
              </ul>
              <div className="card-glow traditional-glow"></div>
            </motion.div>

            {/* VS Divider */}
            <div className="vs-divider">
              <div className="vs-circle">
                <span>VS</span>
              </div>
              <div className="vs-line"></div>
            </div>

            {/* MetroRahi Side */}
            <motion.div
              className="comparison-card metro-rahi"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="card-header">
                <div className="icon-container metro-rahi-icon">
                  <Smartphone className="icon" />
                </div>
                <h3>MetroRahi Experience</h3>
              </div>
              <ul className="feature-list">
                <li>🤖 AI-powered routes</li>
                <li>📡 Live updates</li>
                <li>⚡ Real-time data</li>
                <li>🛤️ Multiple options</li>
                <li>💡 Instant calculations</li>
              </ul>
              <div className="card-glow metro-rahi-glow"></div>
            </motion.div>
          </div>
        </motion.div>

        {/* Benefits Grid */}
        <motion.div
          className="benefits-grid"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          viewport={{ once: true }}
        >
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              className="benefit-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 * index }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
            >
              <div className="benefit-icon" style={{ color: benefit.color }}>
                <benefit.icon />
              </div>
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-description">{benefit.description}</p>
            </motion.div>
          ))}
        </motion.div>

        {/* Transformation Banner */}
        {/* <motion.div
          className="transformation-banner"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.0 }}
          viewport={{ once: true }}
        >
          <div className="banner-content">
            <h3>Transform Your Daily Commute</h3>
            <p>Join smart travelers who have already upgraded their metro experience</p>
            <div className="banner-stats">
              <div className="stat">
                <span className="stat-number">10K+</span>
                <span className="stat-label">Routes Planned</span>
              </div>
              <div className="stat">
                <span className="stat-number">5K+</span>
                <span className="stat-label">Active Users</span>
              </div>
              <div className="stat>
                <span className="stat-number">4.5★</span>
                <span className="stat-label">App Rating</span>
              </div>
            </div>
          </div>
        </motion.div> */}
      </div>
    </section>
  );
};

export default WhyMetroRahiSection;
